<template>
        <v-list-item dense>
            <v-list-item-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Version'"> mdi-shield-star </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Version Type' && value=='new'"> mdi-new-box </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Version Type' && value!='new'">  mdi-tools </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Average Time Spent'"> mdi-timer </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Time Spent'"> mdi-timer </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Average Number Of Attempts to Complete'"> mdi-motion-play </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Module Attempts'"> mdi-motion-play </v-icon>
                <v-icon class="card-image" :color="color"  v-if="title=='Module Progress'"> mdi-progress-check </v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>{{ title | translate }}</v-list-item-title>
                <v-list-item-subtitle v-if="title=='Module Progress'">
                    <v-progress-linear
                        v-if="!isNaN(value)"
                        :value="value"
                        color="#80D59E"
                        height="15"
                    >
                    <strong>{{ Math.ceil(value) }}%</strong>
                    </v-progress-linear>
                    <span v-else>
                        {{value}}
                    </span>
                    
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>{{value}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
</template>

<script>
export default {
  name: 'SmallCard',
    props: {
        title: String,
        value: [String,Number],
        width: Number,
        color: String,
    }
}
</script>

<style scoped>
.card-title{
    font-size: 30px;
}

.v-list-item {
    padding-left: 20px !important;
    color:"red";
}

</style>